<script lang="ts" setup>
import { CUSTOMER_TAB_ROUTER_INFO } from '@/customerForecastModule/constants';
import { useRoute } from 'vue-router';
import HeaderArea from '@/corePagesModule/components/HeaderArea.vue';
import { i18n } from '@/i18n';
import { isEqualRouterInfo } from '../domains/routerInfo';
import BusinessListForecastForReceipt from './BusinessListForecastForReceipt.vue';

const tabInfos = [...CUSTOMER_TAB_ROUTER_INFO];

const route = useRoute();
const t = i18n.t;
</script>

<template>
  <div class="customer-forecast-dashboard">
    <HeaderArea :title="t('forecastForReceipt_title')" />
    <BusinessListForecastForReceipt v-if="route.path.startsWith('/customer/FR')" class="customer-forecast-dashboard__container" />
    <template v-for="info in tabInfos" v-else :key="info.router">
      <component :is="info.component" v-if="isEqualRouterInfo(route, info)" class="customer-forecast-dashboard__container" />
    </template>
  </div>
</template>

<style lang="scss" scoped>
.customer-forecast-dashboard {
  width: 100%;
  height: 100%;
  background-color: $backgroundDefault;
  padding: 0 16px;
  display: grid;
  grid-template-rows: auto 1fr;

  &__container {
    height: 100%;
  }
}
</style>
